export default __webpack_public_path__ + "static/media/BeforePhoto6.e9bb96bf.jpg";